module.exports = __webpack_public_path__ + "img/touch-screen.d1860e12.svg";